import React from 'react';
import {Button, Select} from 'antd';
import * as R from "ramda";
import {getUserContactLists$} from "../../services/users";
import {connect} from "react-redux";
import {currentEffectiveUserId} from "../../reducers/ui";
import {compose} from "redux";
import {withRouter} from "react-router";

const Option = Select.Option;

class ContactListSelection extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      contactLists: [],
      value: []
    };
  }

  componentDidMount() {
    const { userId } = this.props;
    if (userId) {
      this.fetchLists(userId).then(this.updateSelection);
    }
  }

  updateSelection = (contactLists) => {
    if (!contactLists) return;
    contactLists = contactLists.map(item => ({ text: item.name, value: item.id }));
    this.setState({ contactLists });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { userId } = this.props;
    const { userId: prevId } = prevProps;
    if (userId && userId !== prevId) {
      this.fetchLists(userId).then(this.updateSelection);
    }
  }

  handleChange = (value) => {
    this.setState({ value });
  };

  handleFilter = (input, option) => option.props.children.toLowerCase().includes(input.toLowerCase());

  fetchLists = async (userId) => {
    let contactLists = [];
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    do {
      let { response, status: response_status } = await getUserContactLists$({ userId, offset: nextOffset }).toPromise();
      if (!response || response_status === 204) return;
      const { results, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) {
        contactLists = Array.concat(contactLists, results);
        nextOffset = R.last(results).id;
      }
    } while (soFar < theSize);
    return contactLists;
  };

  handleInvite = () => {
    const { onInvite } = this.props;
    const { value } = this.state;
    onInvite && onInvite(value.map(v => v.key));
    this.setState({ value: [] });
    this.props.history.goBack();
  };

  render() {
    const { contactLists, value } = this.state;
    return (
      <div>
        <Select
          className={'contact-list-invite-select'}
          style={{ width: '100%' }}
          placeholder='Choose contact lists to invite'
          mode='multiple'
          labelInValue
          value={value}
          onChange={this.handleChange}
          filterOption={this.handleFilter}
        >
          {contactLists.map(d => <Option key={d.value}>{d.text}</Option>)}
        </Select>
        <Button onClick={this.handleInvite}>Invite</Button>
      </div>
    );
  }
}

export default compose(
  connect(
    (state, props) => ({
      userId: currentEffectiveUserId(state),
    }),
  ),
  withRouter
)(ContactListSelection);



// WEBPACK FOOTER //
// ./src/components/Boilerplate/ContactListSelection.js